import { AxiosError } from 'axios';
import { types, flow, Instance } from 'mobx-state-tree';
import axios from 'utils/axios.config';
import { withAlertStore } from 'components/Core/CustomAlert/store';
import { ErrorData, IResponse } from 'types/common';
import { IChangeCountryStatusReq, ICountryData, ICountryDataReq } from './types';
// import { mockCountriesList } from './mock';

const { model, frozen, maybeNull } = types;

export const CountriesStore = model('CountriesStore', {
  countriesList: maybeNull(frozen<ICountryData[]>()),
  countryData: maybeNull(frozen<ICountryData>()),
})
  .extend(withAlertStore)
  .actions((self) => ({
    setCountriesList(data: ICountryData[] | null) {
      self.countriesList = data;
    },
    setCountryData(data: ICountryData | null) {
      self.countryData = data;
    },
  }))
  .actions((self) => ({
    errorHandling({ response }: AxiosError<IResponse<ErrorData>>) {
      const msg = response?.data.message || 'Internal server error';
      self.alertStore.showAlert(msg);
      throw new Error(msg);
    },
  }))
  .actions((self) => ({
    getCountriesList: flow(function* () {
      yield axios
        .get('countries')
        .then(({ data: { data } }) => self.setCountriesList(data))
        .catch(self.errorHandling);
    }),
    changeCountriesStatus: flow(function* ({ id, status, verificationCode, code }: IChangeCountryStatusReq) {
      yield axios
        .patch(`countries/status/${id}`, { status, verificationCode, code })
        .then(() => {
          if (self.countriesList) {
            self.setCountriesList(self.countriesList.map((item) => (item.id === id ? { ...item, status } : item)));
          }
        })
        .catch(self.errorHandling);
      return id;
    }),
    getCountryData: flow(function* (id: string) {
      yield axios
        .get(`countries/${id}`)
        .then(({ data: { data } }) => self.setCountryData(data))
        .catch(self.errorHandling);
    }),
    addCountry: flow(function* ({ data, verificationCode }: ICountryDataReq) {
      const { code, ...body } = data;
      return yield axios
        .post(`countries`, { data: { ...body, code: code }, verificationCode })
        .then(({ data: { data } }) => data)
        .catch(self.errorHandling);
    }),
    editCountry: flow(function* ({ data, verificationCode }: ICountryDataReq) {
      yield axios.patch(`countries/${data.id}`, { data, verificationCode }).catch(self.errorHandling);
      return null;
    }),
  }));

export type ICountriesStore = Instance<typeof CountriesStore>;
